






























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalSize } from '@/components/modal-size'
import Modal from '@/components/Modal.vue'
import moment from 'moment'
import Button from '@/components/WebView/Button.vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import {
    tomorrowMorning,
    tomorrowAfternoon,
    nextMondayMorning
} from '@/utils/time'

declare const Intl
@Component<NoticeSchedulerModal>({
    components: { Modal, Datetime, Button }
})
export default class NoticeSchedulerModal extends Vue {

    @Prop(Boolean) public show!: boolean
    @Prop(String) public timezone!: string

    private showPredefinedDatePicker = true
    private showCustomDateTimePicker = false

    private customDateTime = moment().add(1, 'hours').add(5, 'minutes').format('YYYY-MM-DDTHH:mm:ss')

    private dateFormat = 'DD MMM, h:mma'
    private pickerOptions = [
        {
            icon: require('@/components/WebView/icons/Sun.svg'),
            name: 'Tomorrow <br>Morning',
            time: tomorrowMorning().format('YYYY-MM-DD HH:mm:ss'),
            displayTime: tomorrowMorning().format(this.dateFormat),
        },
        {
            icon: require('@/components/WebView/icons/HalfSun.svg'),
            name: 'Tomorrow <br>Afternoon',
            time: tomorrowAfternoon().format('YYYY-MM-DD HH:mm:ss'),
            displayTime: tomorrowAfternoon().format(this.dateFormat),
        },
        {
            icon: require('@/components/WebView/icons/Briefcase.svg'),
            name: 'Monday <br>Morning',
            time: nextMondayMorning().format('YYYY-MM-DD HH:mm:ss'),
            displayTime: nextMondayMorning().format(this.dateFormat),
        },
        {
            icon: require('@/components/WebView/icons/Calendar.svg'),
            name: 'Pick <br>Date & Time',
            time: -1,
            displayTime: '<br>',
        }
    ]

    private onClickOption(option) {
        this.showPredefinedDatePicker = false
        if(option.time === -1) {
            this.toggleCustomDateTimePicker()
        } else {
            this.doSchedule(option.time, option.name.replace('<br>', ''))
        }
    }

    private onClose() {
        // to keep the animation, hide the whole component after 200ms
        this.showPredefinedDatePicker = false
        this.showCustomDateTimePicker = false

        setTimeout(()=>{
            this.$emit('close')
            // make sure it shows picker next time open
            this.showPredefinedDatePicker = true
        }, 200)
    }

    private toggleCustomDateTimePicker() {
        this.showCustomDateTimePicker = !this.showCustomDateTimePicker
    }

    private onOkSchedule() {
        // return directly if validate fail
        if (this.customDateTimePickerError) {
            return
        }
        this.showCustomDateTimePicker = !this.showCustomDateTimePicker
        const label = moment(this.customDateTime).format(this.dateFormat)
        const scheduledAt = moment(this.customDateTime).format('YYYY-MM-DD HH:mm:ss')
        this.doSchedule(scheduledAt, label)
    }

    private doSchedule(scheduledAt: string, label: string) {
         this.$emit('schedule', scheduledAt, label)
         this.onClose()
    }

    private onCancelSchedule() {
        this.showPredefinedDatePicker = true
        this.showCustomDateTimePicker = false
    }

    private selectDate(e: Event) {
        setTimeout(() => (this.$refs.customDatePicker as Datetime).open(e), 10)
    }

    private selectTime(e: Event) {
        setTimeout(() => (this.$refs.customTimePicker as Datetime).open(e), 10)
    }

    private get modalSize() {
        return ModalSize
    }

    private get customTimeDisplay() {
        // eg. 2020-03-31T00:00:00.000
        return moment(this.customDateTime).format('hh:mm a')
    }
    private get customDateDisplay() {
        // eg. 2020-03-31T00:00:00.000
        return moment(this.customDateTime.split('T')[0], 'YYYY-MM-DD').format('ddd, DD MMM')
    }

    private get customDateTimePickerError() {
        return moment(this.customDateTime).unix() - moment().unix() < 60 * 60
            ? 'Pick a time at least one hour from now'
            : ''
    }
}
